/*
 * 2026-08-25 (Philip, Runde 68): Die schwebende "Sticky Add to Cart"-Leiste (Shopify-Kern-
 * Komponente, assets/sticky-add-to-cart.js) versteckt sich bisher nur, wenn der Footer in
 * Sicht kommt. Auf Produktseiten mit den Accordion-Punkten "Versand & Zahlung" / "Rueckgabe
 * & Widerruf" (ein einziges Accordion-Element, ID-Suffix "accordion_flx_policies", siehe
 * blocks/accordion.liquid + templates/product.json) liegt zwischen diesem Accordion und dem
 * Footer aber oft nicht genug Platz - auf Mobile (volle Breite, am unteren Bildschirmrand
 * fixiert) ueberdeckt die Leiste dadurch das Accordion, bevor der Footer sichtbar wird.
 * Bewusst NICHT die private Klasse in sticky-add-to-cart.js direkt angefasst (Shopify-
 * Kern-/Vendor-Datei, siehe Lehre aus Runde 59 zu slideshow.js) - stattdessen additiv:
 * eigener Observer setzt eine Klasse, die per CSS (flicks-custom-v3.css) die Leiste
 * zusaetzlich ausblendet, sobald das Policy-Accordion in Sicht kommt.
 */
(function () {
  function initStickyCartFix() {
    var policiesAccordion = document.querySelector('[class*="accordion_flx_policies"]');
    var stickyCarts = document.querySelectorAll('sticky-add-to-cart');
    if (!policiesAccordion || !stickyCarts.length) return;
    if (policiesAccordion.dataset.flxStickyFixBound === 'true') return;
    policiesAccordion.dataset.flxStickyFixBound = 'true';

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyCarts.forEach(function (el) {
            el.classList.toggle('flx-hide-sticky-cart', entry.isIntersecting);
          });
        });
      },
      { rootMargin: '150px 0px 0px 0px' }
    );

    observer.observe(policiesAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCartFix);
  } else {
    initStickyCartFix();
  }
  // Shopify-Theme-Editor: Sections koennen ohne vollen Reload neu gerendert werden
  document.addEventListener('shopify:section:load', initStickyCartFix);
})();
